<template>
    <div class="modal fade" id="customer_modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel">Add / Update Customer: {{customer.name}}</h4>
                </div>
                <form method="post" @submit.prevent="updateCustomer()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="name">Name</label>
                            <input v-model="customer.name" type="text" required="required" class="form-control" id="name" placeholder="Name...">
                        </div>
                        <div class="form-group">
                            <label >Contact 1</label>
                            <input v-model="customer.contact1" type="text" required="required" class="form-control" placeholder="Contact 1...">
                        </div>
                        <div class="form-group">
                            <label>Contact 2</label>
                            <input v-model="customer.contact2" type="text" class="form-control" placeholder="Contact 2...">
                        </div>
                        <div class="form-group">
                            <label>Contact 3</label>
                            <input v-model="customer.contact3" type="text"  class="form-control"  placeholder="Contact 3...">
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input v-model="customer.email" type="email" class="form-control" placeholder="Email...">
                        </div>
                        <div class="form-group" v-if="where === undefined">
                            <label>Status</label>
                            <select v-model="customer.customerStatus" :disabled="customer.customerStatus==='blocked' && userRole!=='ROLE_ADMIN'" class="form-control" required="required">
                                <option value="">Select Status</option>
                                <option value="active">Active</option>
                                <option v-if="userRole==='ROLE_ADMIN' || customer.customerStatus==='blocked'" value="blocked">Blocked</option>
                                <option value="request_to_block">Request To Block</option>
                            </select>
                        </div>
                        <div  class="form-group" v-if="customer.customerStatus !== 'active' && where === undefined">
                            <label>Reasons of black list</label>
                            <textarea :disabled="customer.customerStatus==='blocked' && userRole!=='ROLE_ADMIN'" class="form-control" rows="5" v-model="customer.blockReasons"></textarea>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
    /* eslint-disable */
    export default {
        name: "UpdateCustomer",
        data:function() {
            return {
                customer: {
                    "id": 0,
                    "name": "",
                    "contact1": null,
                    "contact2": null,
                    "contact3": null,
                    "email": null,
                    "blockReasons" : "",
                    "customerStatus": ""
                },
                userRole:''
            };
        },
        props: ["where"],
        mounted: function () {
            console.log(this.where);
            let loggedInUser = this.$store.state.user;
            if(loggedInUser){
                this.userRole = loggedInUser.userRolesById[0].role;
            }            
        },
        methods: {
            load: function (customerId) {
                if(customerId > 0){
                    let params = new URLSearchParams();
                    params.append("customer_id", customerId);
                    this.$http.post(this.$store.state.mainAppURL + "customers/get_customer_detail", params).then(resp => {
                       this.customer = resp.data;
                    });
                }else{
                    this.resetData();
                }
                $("#customer_modal").modal("show");
            },
            updateCustomer: function () {
                Swal.fire({
                    title: 'Please Wait! We are processing the data.',
                    type: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                });
              this.$http.post(this.$store.state.mainAppURL + "customers/update_customer", this.customer).then(resp => {
                  Swal.close();
                  if(resp.data){
                      $("#customer_modal").modal("hide");
                      this.resetData();
                      swal("SUCCESS!", "Customer has been updated successfully!", "success");
                      if(this.where === 'deliveryOrder'){
                          this.$parent.updateCustomerInfoInOrderObject();
                      } else if (this.where === 'customers') {
                        this.$parent.dtTable.draw();
                      }
                  }else{
                      swal("Error!", "Contact Number Already Registered", "error");
                  }
              }).catch(ex => {
                  swal("Error!", ex + "\nPlease try again!!", "error");
              });
            },
            resetData: function () {
                this.customer= {
                }             
            }
        }
    }
</script>

<style scoped>

</style>
